import React from 'react';
import Translate from '../../../core/translate/Translate';
import { combineClassNames } from '../../../core/css';
import { Price } from './Price';
import { Dagger, Asterisk } from '../../common/notifications/NotificationsTrigger';
import { useNotifications } from '../../common/notifications/NotificationsContext';

const Line = ({
  label,
  labelKey,
  value,
  price,
  className,
  disclaimer,
  showSign,
}) => {
  if (!value && !price) {
    return null;
  }
  const { show } = useNotifications();

  return (
    <div className={combineClassNames('math-box__line', className)}>
      <div
        className={`${`${className}__label`}${
          disclaimer ? ` ${className}__label--disclaimer` : ''
        }`}
        onClick={(event) => {
          disclaimer && show(disclaimer, event, null, true);
        }}>
        {label || <Translate value={labelKey} />}
        {disclaimer && (
          <>
            <Dagger className="notification-trigger--no-right" />
            <Asterisk className="notification-trigger-asterisk--no-right" />
          </>
        )}
      </div>
      {price && <div className={`${className}__price`}>{price}</div>}
      {value && (
        <Price className={className} value={value} showSign={showSign} />
      )}
    </div>
  );
};

const MathboxLine = (props) => (
  <Line {...props} className={combineClassNames(props.className)} />
);

const NetLine = (props) => (
  <Line
    {...props}
    className={
      props.className === 'math-box-employee-price'
        ? props.className
        : combineClassNames('math-box-net-price', props.className)
    }
  />
);

export { Line, NetLine, MathboxLine };
